import { Tags } from "./Tags";
import i18n from "../../i18n";

export default class SeparateSurvey {
  constructor(obj = {}) {
    this.deliverableId = obj.deliverableId;
    this.deliveryName = obj.deliveryName || '';
    this.grade = obj.grade || null;
    this.observation = obj.observation || null;
    this.disabled = obj.disabled || false;
    this.disableButton = obj.disableButton || false;
  }

  get tags() {
    if (this.grade === null) {
        return [];
    }
    return this.grade === 5 ? Tags.Positive : Tags.Negative;
  }

  get questionText() {
    return this.grade === 5 ? i18n.global.t('positiveQuestionText') :
      i18n.global.t('negativeQuestionText');
  }
}
